<template>
  <!-- 底部功能按钮区域 -->
  <div class="function-buttons">
    <div class="button-row">
      <!-- 这里根据接口配置动态展示功能按钮 -->
      <div
        v-for="(item, index) in functionItems"
        :key="index"
        class="function-item"
        :style="{ backgroundColor: item.color }"
        @click="handleFunctionClick(item)"
      >
        <div v-if="item.name != '更多应用'" class="function-icon">
          <img :src="item.logo" alt="logo" />
        </div>
        <div v-else class="more-icon-box">
          <img
            src="@/assets/images/laoshibang/more.png"
            alt="logo"
            class="more-icon"
          />
        </div>
        <span class="function-text" :style="{ color: item.fontColor }">{{
          item.name
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppSearchButtons",
  data() {
    return {};
  },
  props: {
    functionItems: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleFunctionClick(item) {
      this.$emit("handleClick", item);
    },
  },
};
</script>
<style scoped>
.function-buttons {
  width: 100%;
  max-width: 800px;
}

.button-row {
  display: flex;
  justify-content: left;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.function-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 5px 10px 5px 5px;
  border-radius: 85px;
  background: #ffffff;
  border: 1px solid #ebebeb;
}

.function-item:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.1);
}

.function-item .function-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.function-item .function-text {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 15px;
  color: #323233;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  /* text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); */
}
.more-icon-box {
  padding: 10px 0px 10px 5px;
}
.more-icon {
  width: 18px !important;
  height: 18px !important;
}
</style>
